// src/pages/AboutPage.js
import React from 'react';
import Metrics_Text from '../components/Metrics_Text';

const AboutPage = ({ selectedCompany, selectedQuarter, metricsData }) => {
  return (
    <div className="w-full">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="w-full">
          {/* eslint-disable-next-line react/jsx-pascal-case */}
          <Metrics_Text
            selectedCompany={selectedCompany}
            selectedQuarter={selectedQuarter}
            metricsData={metricsData}
          />
        </div>
      </div>
    </div>
  );
};

export default AboutPage;


